import request from '../request'


const path='/questionnaire'
const pathInitMenu1='getImgYzm'

export const outpatientQuestion =function (paperId) {
    // return request.post(`${path}${pathInitMenu1}`,{
    // return request.post(`${path}`,{
    // console.log(paperId)
    return request.get('/outpatientQuestion',{
        paperId:paperId,
    })
}

export const hospitalization =function (paperId) {
    return request.get('/hospitalization',{
        paperId:paperId,
    })
}

